import {convertirNumeroConComas} from '../../../../utils/numbers.utils'
import TableDocumentosCRE from '../Table/TableDocumentosCRE'

const TablaFacturacionCRE = (props: any) => {
  return (
    <>
      <div style={{overflowX:"auto", width:"100%"}}><TableDocumentosCRE rows={props?.documentos} sinAcciones={props?.sinAcciones} noAsociar={true} /></div>
      <div className="cf-calculos-producto" style={{width: '100%'}}>
        <table>
          <tbody>
            <TableRowResponsiveCard  text={"Total monto sujeto a retención"}  valor={props?.datos?.totalMontoSujeto} className="cf-total" />
            <TableRowResponsiveCard text={"Total IVA retenido"}  valor={props?.datos?.totalIvaRetenido} className="cf-descuento" />
          </tbody>
        </table>
      </div></>
  )
}

const TableRowResponsiveCard = (props: any) => {
  return (
    <tr className={props?.className}>
      <td>{props.text}</td>
      <td>${convertirNumeroConComas(props?.valor) ?? '0.00'}</td>
    </tr>
  )
}

export default TablaFacturacionCRE
